module.exports = __webpack_public_path__ + "static/img/index-img.7abd668.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/frontPage/assets/index-img.png
// module id = 1WK3
// module chunks = 1